__turbopack_context__.v({
  "headerVariant": "ModuleNav-module__EdS73W__headerVariant",
  "nav": "ModuleNav-module__EdS73W__nav",
  "navbarMobileVariant": "ModuleNav-module__EdS73W__navbarMobileVariant",
  "navbarVariant": "ModuleNav-module__EdS73W__navbarVariant",
  "tab": "ModuleNav-module__EdS73W__tab",
  "tabActive": "ModuleNav-module__EdS73W__tabActive",
  "tabIcon": "ModuleNav-module__EdS73W__tabIcon",
  "tabIconImg": "ModuleNav-module__EdS73W__tabIconImg",
});
